<template>
  <footer id="page-footer" class="bg-body-light">
    <div class="content py-0">
      <div class="row font-size-sm">
        <div class="col-sm-6 order-sm-2 mb-1 mb-sm-0 text-center text-sm-right">
          <a @click="togglePpModal(true)" href="javascript:void(0)">{{$t('layout.pageFooter.privacyPolicy')}}</a> <span class="mx-1"> | </span>
          {{$t('layout.pageFooter.craftedWith')}} <i class="fa fa-heart text-danger"></i> {{$t('layout.pageFooter.by')}} <a class="font-w600" href="https://eosnation.io" target="_blank">{{$t('layout.pageFooter.eosNation')}}</a>
        </div>
        <div class="col-sm-6 order-sm-1 text-center text-sm-left">
          <router-link :to="{ name: 'dashboard' }" class="font-w600">{{$t('layout.pageFooter.' + selectedChain)}} {{$t('layout.pageFooter.detective')}}</router-link> &copy; 2020
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'pageFooter',
  computed: {
    selectedChain () {
      return this.$store.state.options.selectedChain
    }
  },
  methods: {
    ...mapMutations([
      'togglePpModal'
    ])
  }
}
</script>

<style scoped lang="scss">

</style>
